<template>
    <div>
        <!-- <v-alert :color="$root.themeColor" style="border-radius:0;position:sticky;top:0;z-index:1" dense type="info" :value="true">
            Choose attendee to chat with
        </v-alert> -->
        <v-toolbar class="attendeelist_toolbar" :color="$root.themeColor" flat style="color:#fff" extended extension-height="62">
            <v-btn :color="$root.themeColor" icon class="mr-2 white--text" @click="$router.go(-1)">
                <v-icon>{{$root.platform === 'ios' ? 'arrow_back_ios' : 'arrow_back'}}</v-icon>
            </v-btn>
            <v-toolbar-title>Reimbursements</v-toolbar-title>
            <v-spacer></v-spacer>
            
            <v-btn @click="fn_updateConversion()" class="white--text" outlined>
                <v-icon class="mr-1">mdi-cash-sync</v-icon> Update
            </v-btn>
            
            <!-- <div class="pr-4 pt-0 include_guest_btn"><v-switch hide-details @change="fn_isShowGuest" v-model="IsShowGuest" label="Include Guest"></v-switch></div> -->
            <!-- <v-badge :content="unreadMessageCount" :value="unreadMessageCount" color="#f69220" overlap>
                  <v-icon color="white" @click="$root.fn_openChatView">chat</v-icon>
            </v-badge> -->
            <!-- <div slot="extension" solo><v-switch @change="fn_isShowGuest" v-model="IsShowGuest" label="Include Guest"></v-switch></div> -->
            <v-text-field dense grey-back clearable flat solo hide-details placeholder="Search..." v-model="searchValue" @input="fn_debounceSearch" slot="extension"></v-text-field>
            
        </v-toolbar>
  
         <template v-if="loading">
            <div class="pa-8">
                <v-img width="120" style="margin:auto" src="../assets/giphy.gif"></v-img>
            </div>
        </template>

        <div v-show="!loading">
  
          <template v-if="!error">
            <v-list class="pa-0" three-line>
              <template v-for="(item, index) in winners">
                <v-list-item :key="index" class="zindex2 attendeelist_customformatting">
  
                  <v-list-item-avatar @click="fn_gotoChatPage(item.AttendeeID)" class="grey lighten-3" style="align-self: center;">
                      <!-- {{fn_abbreviatedName(item.WinnerName)}} -->
                      <template v-if="item.ImageUrl != null"><v-img alt="winnerimage" :src="item.ImageUrl" lazy-src="../assets/person.svg"></v-img></template>
                      <template v-else>{{fn_abbreviatedName(item.WinnerName)}}</template>
                      
                  </v-list-item-avatar>
  
                  <v-list-item-content @click="fn_gotoChatPage(item.AttendeeID)">
                      <v-list-item-title v-text="item.WinnerName"></v-list-item-title>
                      <v-list-item-subtitle v-if="item.JobTitle">{{item.JobTitle}}</v-list-item-subtitle>
                      <v-list-item-subtitle v-else>STRATEGIC ACCOUNT EXECUTIVE</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="item.AreaName">{{item.AreaName}}</v-list-item-subtitle>
                      <v-list-item-subtitle v-else>Western Europe</v-list-item-subtitle>
                      <v-list-item-subtitle v-if="item.Subsidiary && item.AreaName != item.Subsidiary">{{item.Subsidiary}}</v-list-item-subtitle>
                      <!-- <v-list-item-subtitle v-else>Sweden</v-list-item-subtitle> -->
                      <v-list-item-subtitle v-if="item.RegistrationFormType != 1 && item.Organization != null">{{item.Organization}}</v-list-item-subtitle>
  
                  </v-list-item-content>
  
                    <!-- <v-list-item-icon v-if="item.CanChat" style="margin: auto;" @click="$root.fn_openChatView('instantchat', item.AttendeeID)">
                      <v-icon>mdi-message-outline</v-icon>
                    </v-list-item-icon> -->
                  </v-list-item>
  
                  <v-divider inset :key="index+'divider'" v-if="index != winners.length - 1"></v-divider>
              </template>
                
  
                <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
                  <div slot="no-more"></div>
                  <div slot="no-results" class="pa-4 light-opacity-color">No attendee found!</div>
                </infinite-loading>
            </v-list>
          </template>
  
          <template v-else>
            <div style="text-align:center;" class="pa-4">
                <p>Something went wrong. Please try again.</p>
                <br>
                <v-btn outlined @click="fn_debounceSearch"><v-icon left>refresh</v-icon> Retry</v-btn>
            </div>
          </template>
        </div>
  
        <v-dialog v-model="contentDialog" scrollable transition="dialog-bottom-transition" fullscreen persistent>
          <v-card>
            <v-card-title :style="{ backgroundColor: $root.themeColor}" :color="$root.themeColor"  class="title pb-4 pl-4 white--text" style="flex-wrap:nowrap;word-break: break-word;">
                <v-btn :color="$root.themeColor" icon class="mr-4 white--text" @click="contentDialog = false">
                    <v-icon>{{$root.platform === 'ios' ? 'arrow_back_ios' : 'arrow_back'}}</v-icon>
                </v-btn>
                Reimbursement Details
                <v-spacer></v-spacer>
                <v-menu v-if="isEditing" bottom right :offset-y="true" content-class="viewactns_actionbtns viewactns fixedcolumnactions" min-width="200px">
                    <template v-slot:activator="{ on, attrs }">
                        <!-- <v-btn aria-label="Open Action menu" text icon><v-icon style="font-size:18px" v-bind="attrs" v-on="on">more_vert</v-icon></v-btn> -->
                        <v-btn aria-label="Open Action menu" icon>
                            <v-icon v-bind="attrs" v-on="on" color="white">mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list dense class="pt-0 pb-0">
                        <v-list-item @click="fn_enableEditing()">
                            <v-list-item-title aria-label="Click to delete post">{{isEditing ? 'Cancel Editing' : 'Edit Conversion'}}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="scrollable-content form_dialog_text pa-0 platinumclub_custom_formatting">
              <template v-if="error">
                <div style="text-align:center;" class="pa-4">
                    <p>Something went wrong. Please try again.</p>
                    <br>
                    <v-btn outlined @click="fn_getAttendeeInfo"><v-icon left>refresh</v-icon> Retry</v-btn>
                </div>
              </template>

              <template v-if="loading">
                  <div class="pa-8">
                      <v-img width="120" style="margin:auto" src="../assets/giphy.gif"></v-img>
                  </div>
              </template>

              <template v-else>
                <v-card flat class="mt-0 " v-if="ReimbursementList && ReimbursementList.length>0">
                  <v-card-text class="pb-0">
                    <div class="form_content height100">
                              <div class="page_content_fields">
                               <div class="details_box mb-4">
                                  <v-card v-if="ReimbursementList && ReimbursementList.length>0" class="zindex2 reimbusmentcard ma-4 mt-0 ml-0 mr-0">
                                      <v-card-text flat class="pb-2 pl-4 pr-4 pt-2" style="background-color:#f4f4f4 !important; color: black;">
                                          <!-- <div class="pb-1"><strong>Registration ID: </strong> {{ ReimbursementList[0].RegistrationCode }}</div> -->
                                          <div class="pb-1"><strong>Attendee: </strong> {{ ReimbursementList[0].FirstName }} {{ ReimbursementList[0].LastName }} ({{ReimbursementList[0].Alias}})</div>
                                          <div class="pb-1" v-if="TotalRequested != 0 && TotalRequested != null"><strong>Requested: </strong> {{TripCurrencyCode}} {{TotalRequested}} </div>
                                          <div class="pb-1" v-if="TotalSubmitted != 0 && TotalSubmitted != null"><strong>Pending: </strong> {{TripCurrencyCode}} {{TotalSubmitted}} </div>
                                          <div class="pb-1" v-if="TotalReimbursed != 0 && TotalReimbursed != null"><strong>Reimbursed: </strong> {{TripCurrencyCode}} {{TotalReimbursed}} </div>
                                          <div class="pb-1" v-if="TotalRejected != 0 && TotalRejected != null"><strong>Rejected: </strong> {{TripCurrencyCode}} {{TotalRejected}} </div>
                                          
                                      </v-card-text>
                                  </v-card>
                                  <div class="detailsbox_content pl-0 pb-0 pr-0 pt-2">
                                      <div v-for="(category, categoryindex) in categorizedExpenses" :key="categoryindex">
                                            <div :class="{'pt-4' : categoryindex != 0}" style="font-size: 1rem !important; color: black;">
                                                <b v-if="category.Title == 'Pending'" style="color: orange;">Pending</b>
                                                <b v-if="category.Title == 'Reimbursed'" style="color: green;">{{category.Title}}</b>
                                                <b v-if="category.Title == 'Rejected'" style="color: red;">{{category.Title}}</b>
                                            </div>
                                          <template v-for="(item, index) in category.ListItems">
                                              <v-card class="zindex2 reimbusmentcard ma-4 ml-0 mr-0" :key="index">
                                                  <div class="title-wrapper">
                                                      <v-layout class="tile-section_image ma-0" row wrap>
                                                          <v-flex xs12 sm12 md12 mt-1 mb-1 pl-4 pr-2>
                                                              <div style="display: flex;">
                                                                  <v-checkbox class="mt-1" :disabled="item.CurrencyConversionRate == null || item.CurrencyConversionRate == ''" hide-details v-if="category.Title == 'Pending'" v-model="item.IsProcessed" :value="true"></v-checkbox>
                                                                  <h3 class="title pt-2" style="line-height: 20px; font-size: 0.875rem !important;">{{ item.ExpenseType}} <span style="font-weight: 400;">for</span> {{ item.ExpenseFor }}</h3>
                                                              </div>
                                                          </v-flex>
                                                          <!-- <v-flex xs3 sm3 md3 mt-1 mb-1 pr-4 class="text-right">
                                                              <h3 class="title pt-1" style="font-size: 10pt !important;">{{TripCurrencyCode}} {{ item.ConversionAmount }}</h3>
                                                          </v-flex> -->
                                                      </v-layout>

                                                  </div>
                                                  <v-divider></v-divider>
                                                  <v-card-text class="pb-2 pl-4 pr-4 pt-2">
                                                      <div class="pb-1"><strong>Requested Amount: </strong> {{ item.CurrencyCode }} {{ item.Amount }}</div>
                                                      <div class="pb-1" v-if="!isEditing">
                                                        <strong>Conversion Rate: </strong>
                                                        <span style="color: red;" v-if="item.CurrencyConversionRate == null || item.CurrencyConversionRate == ''">Please set conversion rate.</span>
                                                        <span v-else>1 {{ item.CurrencyCode }} = {{ item.CurrencyConversionRate }} {{TripCurrencyCode}}</span>
                                                      </div>
                                                      <div class="pb-1" v-if="category.Title == 'Pending' && isEditing">
                                                        <div><strong>Conversion Rate</strong></div>
                                                        <v-text-field autocomplete="off" class="pt-0" v-model="item.TempCurrencyConversionRate"></v-text-field>
                                                      </div>
                                                      <div class="pb-1"><strong>Converted Amount: </strong> {{ TripCurrencyCode }} {{ item.ConversionAmount }}</div>
                                                      <div class="pb-1" style="display: flex;" v-if="!item.isEditing">
                                                        <div><strong>Approved Amount: </strong> {{ TripCurrencyCode }} {{ item.ApprovedAmount }}</div>
                                                        <v-btn height="24px" width="24px" class="ml-2 pb-1" v-if="category.Title == 'Pending' && !item.isEditing" @click="fn_editApprovalAmount(categoryindex, index)" icon><v-icon size="18px">edit</v-icon></v-btn>
                                                      </div>
                                                      <div style="display: flex; align-items: center;" class="pb-1" v-if="category.Title == 'Pending' && item.isEditing">
                                                        <div><strong>Approved Amount: </strong></div>
                                                        <v-text-field type="number" style="max-width: 120px;" autocomplete="off" class="pl-4 pt-0" v-model.number="item.TempApprovedAmount" hide-details></v-text-field>
                                                        
                                                      </div>
                                                      <div v-if="category.Title == 'Pending' && item.isEditing" class="pb-2">
                                                            <v-btn class="mt-2" :disabled="item.TempApprovedAmount == null || item.TempApprovedAmount == ''" v-if="category.Title == 'Pending' && item.isEditing" @click="fn_saveApprovalAmount(categoryindex, index)" outlined small><v-icon size="18px">save</v-icon> Save</v-btn>
                                                            <v-btn class="ml-4 mt-2" v-if="category.Title == 'Pending' && item.isEditing" @click="fn_editApprovalAmount(categoryindex, index)" outlined small><v-icon size="18px">close</v-icon> Cancel</v-btn>
                                                      </div>
                                                      <div class="pb-1"><strong>Cell Phone Number: </strong> {{ item.CellPhoneNumber }}</div>
                                                      <div class="pb-1" v-if="item.AdditionalNotes != null && item.AdditionalNotes != ''"><strong>Additional Notes: </strong> {{ item.AdditionalNotes }}</div>
                                                      <div class="pb-1" v-if="category.Title == 'Pending' && item.SubmittedOn != null"><strong>Submitted On: </strong> {{ formattedDate(item.SubmittedOn) }}</div>
                                                      <div class="pb-1" v-if="category.Title == 'Reimbursed' && item.ActionOn != null"><strong>Reimbursed On: </strong> {{ formattedDate(item.ActionOn) }}</div>
                                                      <div class="pb-1" v-if="category.Title == 'Rejected' && item.ActionOn != null"><strong>Rejected On: </strong> {{ formattedDate(item.ActionOn) }}</div>
                                                      <div class="pb-1" v-if="item.ReceiptList && item.ReceiptList.length>0"><strong>Uploaded Receipt: </strong></div>
                                                      <div class="pb-1 pl-2">
                                                          <div class="pb-1" v-for="(file, imageindex) in item.ReceiptList" :key="imageindex">
                                                              {{ imageindex + 1 }}. 
                                                              <a v-if="file.DocumentType == 1" @click="fn_openCarousel(item.ReceiptList, index, imageindex)">Receipt {{ imageindex + 1 }}</a>
                                                              <a v-else @click="$root.fn_checkDynamicPDF(file.DocumentDownloadUrl, file.ReceiptName)">Receipt {{imageindex + 1}}</a>
                                                          </div>
                                                      </div>
                                                      <div class="pb-1" v-if="item.Comment != null && item.Comment != ''"><strong>Comments: </strong> {{ item.Comment }}</div>
                                                      <div class="pb-1" v-if="item.AdminComment != null && item.AdminComment != ''"><strong>Admin Comments: </strong> {{ item.AdminComment }}</div>
                                                      <!-- <div style="color: red; font-size: 10pt;" class="pb-1" v-if="item.CurrencyConversionRate == null || item.CurrencyConversionRate == ''">Please set conversation rate.</div> -->
                                                  </v-card-text>
                                                  <!-- <v-card-actions  :style="item.isEditing ? { display: 'block' } : {}" class="pl-4 pt-0">
                                                    <div v-if="!item.isEditing" class="pb-1"><strong>Approved Amount: </strong> {{ item.ApprovedAmount }}</div>
                                                    <div style="display: flex; align-items: center;" class="pb-1" v-if="category.Title == 'Submitted' && item.isEditing">
                                                        <div><strong>Approved Amount: </strong></div>
                                                        <v-text-field style="max-width: 120px;" autocomplete="off" class="pl-4 pt-0" v-model="item.ApprovedAmount" hide-details></v-text-field>
                                                    </div>
                                                    <v-btn class="pb-1" v-if="category.Title == 'Submitted' && !item.isEditing" @click="fn_editApprovalAmount(categoryindex, index)" icon><v-icon size="18px">edit</v-icon></v-btn>
                                                    <div>
                                                        <v-btn class="mt-2" :disabled="item.ApprovedAmount == null || item.ApprovedAmount == ''" v-if="category.Title == 'Submitted' && item.isEditing" @click="fn_saveApprovalAmount(categoryindex, index)" outlined small><v-icon size="18px">save</v-icon> Save</v-btn>
                                                        <v-btn class="ml-4 mt-2" v-if="category.Title == 'Submitted' && item.isEditing" @click="fn_editApprovalAmount(categoryindex, index)" outlined small><v-icon size="18px">close</v-icon> Cancel</v-btn>
                                                    </div>
                                                  </v-card-actions> -->
                                              </v-card>
                                          </template>
                                      </div>
                                  </div>
                              </div>
                                  
                                
                                 
                                 
                                  <!-- <p class="mb-2" v-if="ItemObj.PrimaryAttendee.ActivityStartTime != null"><b>Activity Start Time: </b>{{ ItemObj.PrimaryAttendee.ActivityStartTime }}</p> -->
                              </div>
                          </div>
                  </v-card-text>
                  
                </v-card>
              </template>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions v-if="!loading">
                <div v-if="TotalReimbursementPaying != 0 && TotalReimbursementPaying != null">
                    <b>Total: {{TripCurrencyCode}} {{TotalReimbursementPaying}}</b>
                </div>
            </v-card-actions>
            <v-card-actions v-if="!loading">
                <!-- <div v-if="TotalReimbursementPaying != 0 && TotalReimbursementPaying != null">
                    <b>Total: {{TripCurrencyCode}} {{TotalReimbursementPaying}}</b>
                </div> -->
                <!-- <v-spacer></v-spacer> -->
                <v-btn :disabled="!isPayCheckOutSelected" :color="$root.themeColor" tile class="btn-white mt-1 pl-3 mb-0 pr-3 white--text confirmation_btn" @click="fn_confirmationDialog(1)">Payout</v-btn>
                <v-btn :disabled="!isCheckOutSelected" :color="$root.themeColor" tile class="btn-white mt-1 pl-3 ml-2 pr-3 white--text confirmation_btn" @click="fn_confirmationDialog(2)">Reject</v-btn>
                <v-btn v-if="isEditing" :color="$root.themeColor" tile class="btn-white mt-1 pl-3 ml-2 pr-3 white--text confirmation_btn" @click="fn_saveConversion()">Save Conversion</v-btn>
                <v-btn v-else :color="$root.themeColor" class="white--text" aria-label="Save Conversion" tile @click="fn_enableEditing()">Edit Conversion</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="ConfirmationDialog" persistent max-width="350">
            <v-card>
                <v-card-title class="pt-2 pb-2 pl-4 pr-4" font-medium noshadow>Confirmation</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-4">
                    <div v-if="ExpenseStatusType == 1">The total reimbursement amount is <b>{{TotalReimbursementPaying}} {{TripCurrencyCode}}</b>.</div>
                    <div v-if="ExpenseStatusType == 1">Are you sure you want to proceed with the payout?</div>
                    <div v-if="ExpenseStatusType == 2" class="pb-1">You are about to decline the reimbursement request totaling <b>{{TotalReimbursementPaying}} {{TripCurrencyCode}}</b>.</div>
                    <div v-if="ExpenseStatusType == 2">Are you sure you want to proceed?</div>
                    <div class="mt-2">
                        <div class="subtitle-1 pt-0">Comments (Optional)</div>
                        <v-textarea name="input-7-1" rows="3" label="" v-model="Comments" outlined hide-details></v-textarea>
                    </div>
                    <div class="mt-2">
                        <div class="subtitle-1 pt-0">Admin Comments (Optional)</div>
                        <v-textarea name="input-7-1" rows="3" label="" v-model="AdminComment" outlined hide-details></v-textarea>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small color="blue darken-1" text @click.native="ConfirmationDialog = false">Close</v-btn>
                    <v-btn small color="blue darken-1" text @click="fn_save()">Confirm</v-btn>
                    <!-- <v-btn small color="blue darken-1" text @click.native="fn_refresApp">Refresh App</v-btn> -->
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="imageCarouseDialog" fullscreen hide-overlay>

            <v-card flat style="height:100%" v-if="Photos && Photos.length">
                <v-toolbar :color="$root.themeColor" flat dark>
                    <v-btn icon @click="imageCarouseDialog=false">
                        <v-icon>{{$root.platform === 'ios' ? 'arrow_back_ios' : 'arrow_back'}}</v-icon>
                    </v-btn>
                    <v-toolbar-title style="line-height:20px;padding-top: 6px;">
                        <div style="font-size:small">{{(activeImageIndex + 1)}} of {{Photos.length}}</div>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="fn_getImage('save')">
                        <v-icon>save_alt</v-icon>
                    </v-btn>
                </v-toolbar>

                <div style="height:calc(100% - 56px);display: flex;align-items: center;">
                    <v-carousel hide-delimiters :continuous="false" height="auto" @change="fn_slideChange" v-model="activeImageIndex">
                        <v-carousel-item v-for="(item,i) in Photos" :key="i" :src="item.ReceiptDownloadUrl ? item.Base64DisplayUrl : item.Base64PhotoUrl">
                            <v-img :src="item.ReceiptDownloadUrl ? item.Base64DisplayUrl : item.Base64PhotoUrl" lazy-src="https://picsum.photos/10/6?image=15" aspect-ratio="1" class="grey lighten-2">
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </v-carousel-item>
                    </v-carousel>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="downloading" persistent width="300">
            <v-card>
                <v-card-text class="pt-4">Downloading...
                    <v-progress-linear indeterminate color="primary" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
  
        
    </div>
  </template>
  
  <script>
  import InfiniteLoading from 'vue-infinite-loading';
  import axios from 'axios';
  // import dialogAttendeeInfo from '../winner_attendee_profile'
  // import { CometChat } from "@cometchat-pro/chat";
  const moment = require('moment');
  var controller = null;
  
  // const controller = new AbortController();
  
    export default {
      data: () => ({
        loading:false,
        winners:[],
        infiniteId: +new Date(),
        pageOffset:0,
        searchValue:'',
        timeoutid:null,
        error:false,
        unreadMessageCount:0,
        IsShowGuest: true,
        contentDialog: false,
        ItemObj: null,
        AttendeeID: null,
        ReimbursementList: [],
        ConfirmationDialog: false,
        ExpenseStatusType: null,
        imageCarouseDialog: false,
        Photos: [],
        activeImageIndex: null,
        imageUrl: null,
        DownloadimageUrl: null,
        imageName: null,
        Comments: null,
        AdminComment: null,
        TripCurrencyCode: null,
        downloading: false,
        isEditing: false,
        categoryIndex: null,
        itemIndex: null
      }),
      components: {
        InfiniteLoading,
        // 'dialog-attendee-info':dialogAttendeeInfo
      },
      methods:{
        fn_debounceSearch: function(){
          console.log('debounce');
          if (this.timeoutid != null){
            clearTimeout(this.timeoutid);
          }
  
          this.timeoutid = setTimeout(() => { 
            this.error = false;
            this.pageOffset = 0;
            this.winners = [];
            this.infiniteId = +new Date();
          },500);
        },

        formattedDate(date) {
          if(date)
            return moment(date).format('MMMM DD, YYYY hh:mm A')
        },
  
        infiniteHandler($state) { 
          this.error = false;
          this.$root.fn_getToken(token=>{
              if(token == 'error'){
                this.error = true; 
                this.$root.fn_showToast('exception');
              }
              else{
                  if(controller){
                    controller.abort();
                    console.log('Fetch aborted');
                  }
                  
                  controller = new AbortController();
  
                  var headersObj = {
                    headers: { 
                          'Authorization': 'bearer ' +  token,
                        }
                    };
  
                  let postObj = {}
                  postObj.keywords = this.searchValue;
                  postObj.IsGuestSearchEnable = this.IsShowGuest;
  
                  console.log(JSON.stringify(postObj));
  
                  // axios.post(this.$root.baseUrl + "/api/mobileapp/admin/onsiteview/attendee/list", postObj, headersObj, {timeout:30000}, {signal: controller.signal})
                  axios.post(this.$root.baseUrl + "/api/mobileapp/admin/attendees/expense/list?offset="+this.pageOffset+"&limit=30", postObj, headersObj, {timeout:30000}, {signal: controller.signal})
                  .then(response => {
                      console.log(response);
                      if(response.data.Count > this.winners.length){
                        for(let i=0; i<response.data.ListData.length; i++){
                            this.winners.push(response.data.ListData[i]);
                        }
                        $state.loaded();
                      }
                      else{
                        $state.complete();
                      }
                      controller = null;
                      this.fn_photoAuthThumbnail();
                      this.pageOffset = this.winners.length;
                  }).catch(e => {
                      console.log(e);
                      if(e.response.data == "Token Expired"){
                        this.fn_debounceSearch();
                      }
                      else{
                        let toastMsg = e && e.message ? e.message : 'exception';
                        this.$root.fn_showToast(toastMsg);
                        this.error = true;
                      }
                  })
              }
          })
          
        },
  
        fn_gotoChatPage: function(attendeeid){
          this.contentDialog = true;
          this.AttendeeID = attendeeid;
          this.ExpenseStatusType = null;
          this.fn_getAttendeeInfo();
        },

        fn_abbreviatedName: function(str){
            if(!str){
              return ''
            }
            //let words = str.trim().split(' ');
            //words = words.replace(/ +(?= )/g,'');
            let words = str.trim().replace(/ +(?= )/g,'').split(' ');

            if(words.length > 1){
                return words[0][0].toUpperCase() + words[1][0].toUpperCase();    
            }
            else{
                return words[0][0].toUpperCase();
            }
        },

        fn_isShowGuest: function(){
          this.fn_debounceSearch();
        },

        async fn_photoAuthThumbnail() {
          let self = this;
          // this.loading = true;
          // this.error = false;

          const batchSize = 5; // Size of each batch

          // Filter winners to get those that have an ImageUrl and are not already base64
          const winnersWithImages = self.winners.filter(winner => winner.ImageUrl && !winner.ImageUrl.startsWith('data:image/'));

          // If there are no winners with valid ImageUrl, return early
          if (winnersWithImages.length === 0) {
            //   this.loading = false;
              return;
          }

          // Function to process a batch of winners
          const processBatch = async (batch) => {
              try {
                  // Prepare the list of AttendeeIds and ImageUrls to send in the POST request
                  const imagePayload = batch.map(winner => ({
                      AttendeeID: winner.AttendeeID,
                      PhotoUrl: winner.ImageUrl
                  }));

                  const token = await new Promise((resolve, reject) => {
                      this.$root.fn_getToken((token) => {
                          if (token === 'error') {
                              reject('Token error');
                          } else {
                              resolve(token);
                          }
                      });
                  });

                  console.log(token + " Token Called");

                  const headersObj = {
                      headers: { 
                          'Authorization': 'Bearer ' + token,
                      }
                  };

                  console.log(self.$root.baseUrl);

                  // Send the POST request with the array of AttendeeId and ImageUrl pairs
                  const response = await axios.post(
                      self.$root.baseUrl + '/api/mobileapp/Document/Download/Url/list', // Change to your POST endpoint
                      imagePayload,          // Send array of AttendeeId and ImageUrl pairs
                      headersObj,
                      { timeout: 30000 }
                  );

                  console.log(response.data);

                  // Update winners' ImageUrl based on the response, matching AttendeeId
                  response.data.forEach(respItem => {
                      const matchedWinner = self.winners.find(winner => winner.AttendeeID === respItem.AttendeeID);
                      if (matchedWinner) {
                          matchedWinner.ImageUrl = 'data:image/png;base64,' + respItem.Base64;
                          console.log(matchedWinner.ImageUrl);
                      }
                  });

                  self.$forceUpdate();
              } catch (e) {
                //   self.error = true;
                  console.log(e);
                  throw e; // Stop further processing on error
              }
          };

          try {
              if (winnersWithImages.length <= 5) {
                  // If the number of items with ImageUrl is less than or equal to 5, process them in one call
                  await processBatch(winnersWithImages);
              } else {
                  // Otherwise, split them into batches of 5
                  for (let i = 0; i < winnersWithImages.length; i += batchSize) {
                      const batch = winnersWithImages.slice(i, i + batchSize);
                      await processBatch(batch); // Process each batch sequentially
                  }
              }
          } catch (error) {
              console.log('Batch processing failed', error);
          } finally {
            //   this.loading = false;
              this.error = false;
          }
        },

        fn_getAttendeeInfo: function(){
          this.Comments = null;
          this.AdminComment = null,
          this.ItemObj = null;
          this.contentDialog = true;
          this.loading = true;
          this.error = false;
          this.TripCurrencyCode = null;
          this.isEditing = false;
          this.$root.fn_getToken(token=>{
              if(token == 'error'){
              this.loading = false;
              this.error = true;
              this.$root.fn_showToast('exception');
              }
              else{
                  var headersObj = {
                  headers: {
                          'Authorization': 'bearer '+token,
                      }
                  };

                  axios.get(this.$root.baseUrl + "/api/mobileapp/admin/attendees/expense/"+this.AttendeeID + "/view", headersObj, {timeout:30000})
                  .then(response => {
                      console.log(response);
                      this.loading = false;
                      this.ReimbursementList = response.data;
                      this.TripCurrencyCode = this.ReimbursementList[0].TripCurrencyCode;
                      if (this.ReimbursementList.length> 0) {
                        for (var i in this.ReimbursementList) {
                            for (var j in this.ReimbursementList[i].ReceiptList) {
                                this.ReimbursementList[i].ReceiptList[j].Base64DisplayUrl = null;
                                this.ReimbursementList[i].ReceiptList[j].Base64PhotoUrl = null;
                            }
                        }
                        this.ReimbursementList = this.ReimbursementList.map(item => ({
                            ...item,
                            IsProcessed: item.ExpenseStatus !== 'Pending',
                            TempCurrencyConversionRate: item.CurrencyConversionRate,
                            TempApprovedAmount: item.ApprovedAmount,
                            isEditing: false
                        }));
                      }
                      // this.fn_photoAuth();
                  }).catch(e => {
                      console.log(e);
                      this.loading = false;
                      this.error = true;
                      let toastMsg = e && e.message ? e.message : 'exception';
                      this.$root.fn_showToast(toastMsg);
                  })
              }
          })
        },

        fn_confirmationDialog: function (type) {
            this.ExpenseStatusType = type;
            this.ConfirmationDialog = true;
            this.Comments = null;
            this.AdminComment = null;
        },

        fn_save: function () {
          this.ItemObj = null;
          this.contentDialog = true;
          this.loading = true;
          this.error = false;
          this.ConfirmationDialog = false;
          this.$root.fn_getToken(token=>{
              if(token == 'error'){
              this.loading = false;
              this.error = true;
              this.$root.fn_showToast('exception');
              }
              else{
                  var headersObj = {
                  headers: {
                          'Authorization': 'bearer '+token,
                      }
                  };
                  var formList = this.fn_processPostData();
                  axios.post(this.$root.baseUrl + "/api/mobileapp/admin/attendees/expense/set/status", formList, headersObj, {timeout:30000})
                  .then(response => {
                      console.log(response);
                      // this.loading = false;
                      this.fn_getAttendeeInfo();
                      // this.fn_photoAuth();
                  }).catch(e => {
                      console.log(e);
                      this.loading = false;
                      this.error = true;
                      let toastMsg = e && e.message ? e.message : 'exception';
                      this.$root.fn_showToast(toastMsg);
                  })
              }
          })
        },

        fn_processPostData: function () {
            const newList = [];
            var self = this;
            this.categorizedExpenses.forEach(category => {
                if (category.Title === 'Pending') {
                    category.ListItems.forEach(item => {
                        if (item.IsProcessed === true) {
                            newList.push({
                                MobileAttendeeExpenseID: item.MobileAttendeeExpenseID,
                                ExpenseStatus: self.ExpenseStatusType,
                                Comment: this.Comments != '' &&  this.Comments != null ? this.Comments : null,
                                AdminComment: this.AdminComment != '' && this.AdminComment != null ? this.AdminComment : null
                            });
                        }
                    });
                }
            });

            return newList;

        },

         fn_slideChange: function(index){
            this.DownloadimageUrl = this.Photos[index].ReceiptUrl;
            this.imageUrl = this.Photos[index].ReceiptDownloadUrl;
            this.imageName = this.Photos[index].ReceiptName;
            this.fn_photoAuth(index);
        },

        fn_openCarousel: function(imageItem, itemIndex, imageIndex){
            // this.CrauselOpenType = type;
            var ReceiptName = imageItem[imageIndex].ReceiptName;
            this.Photos = imageItem.filter(doc => doc.DocumentType === 1);
            var currentimageIndex = this.Photos.findIndex(doc => doc.ReceiptName === ReceiptName);
            this.activeItemIndex = itemIndex;
            this.activeImageIndex = currentimageIndex;
            this.imageUrl = imageItem[imageIndex].ReceiptDownloadUrl;
            this.DownloadimageUrl = imageItem[imageIndex].ReceiptUrl;
            this.imageName = imageItem[imageIndex].ReceiptName;
            this.fn_photoAuth(this.activeImageIndex);
            this.imageCarouseDialog = true;
        },

        fn_photoAuth: function(index) {

            this.loading = true;
            this.error = false;
            let self = this;

            if (!((self.Photos[index].Base64DisplayUrl && self.Photos[index].Base64DisplayUrl.startsWith('data:image/')) || 
                (self.Photos[index].Base64PhotoUrl && self.Photos[index].Base64PhotoUrl.startsWith('data:image/')))){
                this.$root.fn_getToken(token=>{
                    if(token == 'error'){
                        this.loading = false;
                        this.error = true;
                        this.$root.fn_showToast('exception');
                    }
                    else{
                        var headersObj = {
                            headers: { 
                                'Authorization': 'bearer '+token,
                            }
                        };

                        console.log(self.$root.baseUrl);
                        var apiUrl = self.Photos[index].ReceiptDownloadUrl ? self.Photos[index].ReceiptDownloadUrl : null
                        var getUrl = self.$root.baseUrl + apiUrl;
                        console.log(getUrl);
                        axios.get(getUrl, headersObj, {timeout:30000})
                        .then(response => {
                            if (self.Photos[index].ReceiptDownloadUrl !== null) {
                                self.Photos[index].Base64DisplayUrl = 'data:image/png;base64,' + response.data;
                            } else {
                                self[index].Base64PhotoUrl = 'data:image/png;base64,' + response.data;
                            }
                            
                            console.log(self.Photos[index].ReceiptDownloadUrl);
                            self.$forceUpdate();
                        }).catch(e => {
                            this.loading = false;
                            // this.error = true;
                            let toastMsg = e && e.message ? e.message : 'exception';
                            this.$root.fn_showToast(toastMsg);
                            console.log(e);
                        })
                    }
                })

            }

            this.loading = false;
            this.error = false;
        },

        handleDownloadingPDF(data) {
            if(data){
                this.downloading = true;
            }
            else
                this.downloading = false;
            console.log("Event received:", data);
        },

        fn_getImage: function(){
            // this.$root.fn_postClickMetrics('Download Photo', this.imageName, this.$route.params.albumId);
            if(this.$root.platform === 'ios'){
                this.fn_openImage();
            }
            else{
                this.$root.fn_checkStoragePermission(response=>{
                    if(JSON.parse(response)){
                        this.fn_openImage();
                    }
                    else{
                        this.$root.fn_showToast('Please allow storage permission');
                    }
                })
            }
        },

        fn_openImage: function(){
            let self = this;
            this.getData('GetImage', this.imageName, 
            {
                onSuccess: function(response){
                    console.log(response);
                    let isDownloaded = JSON.parse(response);
                    if(isDownloaded){
                        self.$root.fn_showToast("Added to Photos");
                    }
                    else{
                        self.fn_downloadImage();
                    }
                },
                onError: function(error){
                    console.log(error);
                    if(error.dataKey && !JSON.parse(error.dataKey)){
                        self.fn_downloadImage();
                    }
                }
            });
        },

        fn_downloadImage: function(){
            let self = this;
            let dataObj = {};
            dataObj.FileName = this.imageName;
            dataObj.FileUrl = this.$root.baseUrl + "/api/mobileapp/Document/Download/Url?filename=" + this.DownloadimageUrl;
            dataObj.DisplayName = this.imageName;
            this.$root.platform === 'android' ? dataObj.IsImageFile = true : '';
            this.downloading = true;
            this.getServerData('DownloadFile', dataObj, {
                onSuccess: function(response){
                    console.log(response);
                    self.downloading = false;
                    self.$root.platform === 'android' ? self.$root.fn_showToast('Added to Photos') : '';
                    self.$root.platform === 'ios' ? self.fn_saveImage() : self.$root.fn_showToast('Added to Photos');
                }, 
                onError: function(error){
                    console.log(error);
                    self.downloading = false;
                    self.$root.fn_showToast('exception');
                }, 
            });
        },

        fn_saveImage: function(){
            let self = this;
            this.getData('SaveImageToPhotoLibrary', this.imageName, 
                {
                    onSuccess: function(response){
                        console.log(response);
                        self.$root.fn_showToast('Added to Photos');
                    },
                    onError: function(error){
                        console.log(error);
                    }
                }
            );
        },

        fn_updateConversion: function(){
          this.loading = true;
          this.error = false;
          this.$root.fn_getToken(token=>{
              if(token == 'error'){
              this.loading = false;
              this.error = true;
              this.$root.fn_showToast('exception');
              }
              else{
                  var headersObj = {
                  headers: {
                          'Authorization': 'bearer '+token,
                      }
                  };

                  axios.get(this.$root.baseUrl + "/api/mobileapp/admin/attendees/expense/set/currencyrate/conversion/bulk/initiate", headersObj, {timeout:30000})
                  .then(response => {
                      console.log(response);
                      this.loading = false;
                  }).catch(e => {
                      console.log(e);
                      this.loading = false;
                      this.error = true;
                      let toastMsg = e && e.message ? e.message : 'exception';
                      this.$root.fn_showToast(toastMsg);
                  })
              }
          })
        },

        fn_enableEditing: function () {
            this.isEditing = !this.isEditing;
            if (!this.isEditing) {
                this.categorizedExpenses.forEach(category => {
                    if (category.Title === 'Pending') {
                        category.ListItems.forEach(item => {
                            item.TempCurrencyConversionRate = item.CurrencyConversionRate
                        });
                    }
                });
            }
        },

        fn_saveConversion: function () {
          this.loading = true;
          this.error = false;
          this.$root.fn_getToken(token=>{
              if(token == 'error'){
              this.loading = false;
              this.error = true;
              this.$root.fn_showToast('exception');
              }
              else{
                  var headersObj = {
                  headers: {
                          'Authorization': 'bearer '+token,
                      }
                  };
                  var formList = this.fn_processConversionPostData();
                  axios.post(this.$root.baseUrl + "/api/mobileapp/admin/attendees/expense/set/currencyrate/conversion", formList, headersObj, {timeout:30000})
                  .then(response => {
                      console.log(response);
                      // this.loading = false;
                      this.fn_getAttendeeInfo();
                      // this.fn_photoAuth();
                  }).catch(e => {
                      console.log(e);
                      this.loading = false;
                      this.error = true;
                      let toastMsg = e && e.message ? e.message : 'exception';
                      this.$root.fn_showToast(toastMsg);
                  })
              }
          })
        },

        fn_processConversionPostData: function () {
            const newList = [];
            this.categorizedExpenses.forEach(category => {
                if (category.Title === 'Pending') {
                    category.ListItems.forEach(item => {
                        if (item.TempCurrencyConversionRate != null && item.TempCurrencyConversionRate != '') {
                            newList.push({
                                MobileAttendeeExpenseID: item.MobileAttendeeExpenseID,
                                CurrencyConversionRate: item.TempCurrencyConversionRate
                            });
                        }
                    });
                }
            });

            return newList;
        },

        fn_editApprovalAmount: function(category, index){
            this.categoryIndex = category;
            this.itemIndex = index;
            this.categorizedExpenses[category].ListItems[index].isEditing = !this.categorizedExpenses[category].ListItems[index].isEditing;
            if (!this.categorizedExpenses[category].ListItems[index].isEditing) {
                this.categorizedExpenses[category].ListItems[index].TempApprovedAmount = this.categorizedExpenses[category].ListItems[index].ApprovedAmount;
            }
        },

        fn_saveApprovalAmount: function (categoryindex, index) {
          this.loading = true;
          this.error = false;
          this.$root.fn_getToken(token=>{
              if(token == 'error'){
              this.loading = false;
              this.error = true;
              this.$root.fn_showToast('exception');
              }
              else{
                  var headersObj = {
                  headers: {
                          'Authorization': 'bearer '+token,
                      }
                  };
                  var formObj = {};
                  formObj.MobileAttendeeExpenseID = this.categorizedExpenses[categoryindex].ListItems[index].MobileAttendeeExpenseID;
                //   formObj.ApprovedAmount = this.categorizedExpenses[categoryindex].ListItems[index].ApprovedAmount;
                  formObj.ApprovedAmount = this.categorizedExpenses[categoryindex].ListItems[index].TempApprovedAmount;
                  axios.post(this.$root.baseUrl + "/api/mobileapp/admin/attendees/expense/save/approvedamount", formObj, headersObj, {timeout:30000})
                  .then(response => {
                      this.categorizedExpenses[categoryindex].ListItems[index].isEditing = false;
                      console.log(response);
                      // this.loading = false;
                      this.fn_getAttendeeInfo();
                      // this.fn_photoAuth();
                  }).catch(e => {
                      console.log(e);
                      this.loading = false;
                      this.error = true;
                      let toastMsg = e && e.message ? e.message : 'exception';
                      this.$root.fn_showToast(toastMsg);
                  })
              }
          })
        },


  
      },
      mounted(){
        this.$eventHub.$on("downloadingpdf", this.handleDownloadingPDF);
      },
      computed:{
        categorizedExpenses() {
            const statusOrder = ['Reimbursed', 'Rejected', 'Pending'];
            const grouped = this.ReimbursementList.reduce((acc, expense) => {
                const status = expense.ExpenseStatus || 'Unknown';
                if (!acc[status]) acc[status] = [];
                acc[status].push(expense);
                return acc;
            }, {});
            return statusOrder
            .filter(status => grouped[status]) // Only include existing ones
            .map(status => ({
                Title: status,
                ListItems: grouped[status]
            }));
        },

          isCheckOutSelected() {
              return this.categorizedExpenses.some(category =>
                  category.Title === 'Pending' &&
                  category.ListItems.some(item => item.IsProcessed === true)
              );
          },

          isPayCheckOutSelected() {
                return this.categorizedExpenses.some(category =>
                    category.Title === 'Pending' &&
                    category.ListItems.some(item => item.IsProcessed === true && item.CurrencyConversionRate != null && item.CurrencyConversionRate != '')
                );
          },

          TotalReimbursed() {
                var total = this.ReimbursementList
                  .filter(item => item.ExpenseStatus === "Reimbursed" && item.ApprovedAmount != null && !isNaN(parseFloat(item.ApprovedAmount)))
                  .reduce((total, item) => total + item.ApprovedAmount, 0);

                return parseFloat(total.toFixed(2));
          },

          TotalRejected() {
              var total = this.ReimbursementList
                  .filter(item => item.ExpenseStatus === "Rejected" && item.ApprovedAmount != null && !isNaN(parseFloat(item.ApprovedAmount)))
                  .reduce((total, item) => total + item.ApprovedAmount, 0);
                return parseFloat(total.toFixed(2));
          },

          TotalSubmitted() {
                var total = this.ReimbursementList
                  .filter(item => item.ExpenseStatus === "Pending" && item.ApprovedAmount != null && !isNaN(parseFloat(item.ApprovedAmount)))
                  .reduce((total, item) => total + item.ApprovedAmount, 0);
                return parseFloat(total.toFixed(2));
          },

          TotalRequested() {
            var total = this.ReimbursementList
                .filter(item => item.ConversionAmount != null)
                .reduce((total, item) => total + item.ConversionAmount, 0);
            return parseFloat(total.toFixed(2));
          },

          TotalReimbursementPaying() {
            var total = this.categorizedExpenses
                .filter(category => category.Title === 'Pending')
                .flatMap(category => category.ListItems || [])
                .filter(item => item.IsProcessed && item.ApprovedAmount != null && !isNaN(parseFloat(item.ApprovedAmount)))
                .reduce((total, item) => total + item.ApprovedAmount, 0);
            return parseFloat(total.toFixed(2));
        }
      }
    }
  </script>
<style>

.reimbursementform .v-card__actions {
    display: block !important;
}

.v-dialog .v-card .v-window-item .v-image.v-responsive{
    height: 100% !important;
}

</style>